/** The part of a route match that `deepestRouteId` reads. */
export type RouteIdMatches = readonly { route: { id: string } }[];

/** Returns the id of the deepest matched route, or `undefined` when nothing matched. */
export function deepestRouteId(matches: RouteIdMatches): string | undefined {
  return matches[matches.length - 1]?.route.id;
}
